import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  set4dGameSubChildtype,
  set4dGameSubtype,
  setCommonConfig,
} from "../../../../redux/actions.js";

import leftArrow from "../../../../assets/images/Icons/left_arrow.svg";
import rightArrow from "../../../../assets/images/Icons/right_arrow.svg";
import { withTranslation } from "react-i18next";
import CoachMarkPopup from "../../../Popups/CoachMarkPopup.js";
import FiveDSixDs from "./FiveDSixDMain.js";

const FiveSixDGame = (props) => {
  // const {coachText, coachStep}= props;
  const dispatch = useDispatch();
  const app_type = useSelector((state) => state.CommonConfig.app_type);
  const device = useSelector((state) => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const game_sub_type = useSelector((state) => state.GameSubType.game_sub_type);
  const marketStatus = useSelector((state) => state.CommonConfig.discount);
  const quickbuyStatus = useSelector((state) => state.CommonConfig.discount);
  const currentStep = useSelector((state) => state.paginationData.currentStep);

  const [activeTab, setActiveTab] = useState("5d");
  const [showArrow, setShowArrow] = useState(false);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const subGameOnOffStatus = useSelector(
    (state) => state.CommonConfig.subGameOnOffStatus
  );
  const marketCloseStatus = useSelector(
    (state) => state.CommonConfig.marketCloseStatus
  );
  const user_balance = useSelector((state) => state.UserBalance.user_balance);
  const tabsElement = useRef(null);

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    dispatch(set4dGameSubtype({ key: "game_sub_type", value: tabIndex }));
    dispatch(
      set4dGameSubChildtype({
        key: "game_sub_child_type",
        value:
          tabIndex == "1"
            ? "DISCOUNT"
            : tabIndex == "2"
              ? "FULLBET"
              : tabIndex == "3"
                ? "PRIZE"
                : "",
      })
    );
    dispatch(setCommonConfig({ key: "clickTab", value: 1 }));
  };

  useEffect(() => {
    setActiveTab("5d");
    dispatch(set4dGameSubtype({ key: "game_sub_type", value: "5d" }));
    dispatch(
      set4dGameSubChildtype({ key: "game_sub_child_type", value: "DISCOUNT" })
    );
  }, []);

  const isHorizontalScroll = (element) => {
    return element.scrollWidth > element.clientWidth;
  };
  useEffect(() => {
    const element = tabsElement.current;
    if (element && isHorizontalScroll(element)) {
      setShowArrow(true);
    } else {
      setShowArrow(false);
    }
  }, [isHorizontalScroll]);
  const updateArrowsVisibility = () => {
    const element = tabsElement.current;
    if (element) {
      setShowLeftArrow(element.scrollLeft > 0);
      setShowRightArrow(
        element.scrollLeft < element.scrollWidth - element.clientWidth
      );
    }
  };

  useEffect(() => {
    const element = tabsElement.current;
    if (element && showArrow) {
      updateArrowsVisibility();
    }
  }, [activeTab, showArrow]);

  const scrollTabs = (direction) => {
    const element = tabsElement.current;
    if (element) {
      const childWidth = element.firstChild.clientWidth;
      const scrollAmount = childWidth; // Adjust the scroll amount as needed
      if (direction === "left") {
        element.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      } else if (direction === "right") {
        element.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    }
  };

  return (
    <div className="fourd-wrapper">
      <div style={{ isolation: "isolate" }} className={`custom-tooltip-wrapper ${currentStep === 1 ? "highlighted" : ""}`}>
        {showArrow && (
          <>
            {showLeftArrow && (
              <div className="arrow_btns">
                <div
                  className="arrow_btn left_arrow_btn"
                  onClick={() => scrollTabs("left")}
                >
                  <img src={leftArrow} alt="Left Arrow" />
                </div>
              </div>
            )}
            {showRightArrow && (
              <div className="arrow_btns">
                <div
                  className="arrow_btn right_arrow_btn"
                  onClick={() => scrollTabs("right")}
                >
                  <img src={rightArrow} alt="Right Arrow" />
                </div>
              </div>
            )}
          </>
        )}
        <div
          // className="navigational-tabwrapper"
          className={`navigational-tabwrapper ${currentStep === 1 ? "disabled" : ""
            }`}
          ref={tabsElement}
          onScroll={updateArrowsVisibility}
        >
          {device == "Desktop" ? (
            <div
              className={`tab custom-tooltip-wrapper ${activeTab === "5d" ? "active" : ""
                } ${currentStep === 1 ? "highlighted" : ""} `}
              onClick={() => handleTabClick("5d")}
            >
              5D
            </div>

          ) : null}
          {device == "Desktop" ? (
            <div
              className={`tab custom-tooltip-wrapper ${activeTab === "6d" ? "active" : ""
                } ${currentStep === 1 ? "highlighted" : ""} `}
              onClick={() => handleTabClick("6d")}
            >
              6D
            </div>

          ) : null}
        </div>
      </div>

      <div className="tabcontent-wrapper">
        {activeTab === "5d" && (
          <div>
            <FiveDSixDs />
          </div>
        )}
      </div>

      {/* {currentStep == 1 && <DummyCoachMark />} */}
      {currentStep == 1 && <CoachMarkPopup />}

    </div>
  );
};

export default withTranslation()(FiveSixDGame);
